module.exports = __webpack_public_path__ + "static/media/cucumber.e2a4e151.jpg";